import { useEffect, useRef } from "react";
import { useLocation } from "wouter";
import { useIsAuthenticated } from "@/hooks/use-auth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useIsAuthenticated();
  const [, setLocation] = useLocation();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!isAuthenticated && !hasRedirected.current) {
      hasRedirected.current = true;
      const currentPath = window.location.pathname + window.location.search;
      // Use window.location.replace to avoid adding to history
      window.location.replace(`/login?redirect=${encodeURIComponent(currentPath)}`);
    }
    // Reset redirect flag when authenticated
    if (isAuthenticated) {
      hasRedirected.current = false;
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
